import { connect } from '@cerebral/react'
import { Box, Icon, Typography } from '@mui/material'
import { sequences, state } from 'cerebral'
import { mergeRight } from 'ramda'
import React from 'react'
import { mergePropsFactory } from '../../lib/util/cerebral'

const Sortable = connect(
  {
    setSort: sequences`route.setSort`,
    sort: state`route.params.$sort`,
  },

  mergePropsFactory(mergeRight),

  ({ name, children, sort = {}, setSort }) => {
    sort = sort[name]
    return (
      <Box display="flex" alignItems="center" style={{ cursor: 'pointer' }}>
        <Typography variant="h6" onClick={() => setSort({ sort: { [name]: sort === 1 ? -1 : 1 } })}>
          {children}
        </Typography>
        {sort && <Icon>{sort === -1 ? 'arrow_drop_down' : 'arrow_drop_up'}</Icon>}
      </Box>
    )
  }
)

export default Sortable
